export const PAYMENT_REQUEST_ROUTING = [
    {
        path: '/payment-request',
        name: 'payment-request',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Yêu cầu giao hàng', pathName: 'payment-request', icon: 'fa fa-check-square-o' },
            ]
        },
        component: () => import('./PaymentRequest.vue'),
        redirect: { name: 'payment-request-index' },
        children: [
            { 
                path: '/yeu-cau-giao-hang.html',
                name: 'payment-request-index',
                component: () => import('./components/main-payment-request/MainPaymentRequest.vue')
            },
            {
                path: '/payment-request/yeu-cau-giao-hang-moi-step1.html',
                name: 'payment-request-new',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo mới yêu cầu giao hàng', pathName: 'payment-request-new-step1', icon: 'fa fa-check-square-o' },
                ] },
                component: () => import('./components/add-new-payment-request-step1/AddNewPaymentRequest.vue'),
            },
            {
                path: '/payment-request/yeu-cau-giao-hang-moi-step2.html',
                name: 'payment-request-new-step2',
                meta: {
                    breadcrumb: [
                        { name: 'Thông tin vận chuyển', pathName: 'payment-request-new-step2', icon: 'fa fa-check-square-o' },
                ] },
                component: () => import('./components/add-new-payment-request-step2/AddNewPaymentRequest.vue'),
            },
            {
                path: '/yeu-cau-giao-hang/:id',
                name: 'payment-request-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết yêu cầu giao hàng', pathName: 'payment-request-detail', icon: 'fa fa-check-square-o' },
                ] },
                component: () => import('./components/detail-payment-request/DetailPaymentRequest.vue'),
            }
        ]
    }
];